import { jsx as l, jsxs as a } from "react/jsx-runtime";
function i({
  children: s,
  label: n,
  subLabel: e
}) {
  return /* @__PURE__ */ l("div", { className: "w-full", children: /* @__PURE__ */ a("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ l("span", { className: "mb-2 font-bold", children: n }),
    e ? /* @__PURE__ */ l("span", { className: "text-sm mb-2", children: e }) : null,
    s
  ] }) });
}
export {
  i as InputWithLabel
};
//# sourceMappingURL=InputWithLabel.js.map
